module.exports = __webpack_public_path__ + "static/images/cog.e076bd233571caf7b511d3aaa5e2fce7.svg";